<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2" id="calibre_pb_0"></div>
<p class="p_norm-center__and__page_break" id="auto_bookmark_toc_1"><span>For Lynn, who is on my journey with me, Lisa, who makes everything better, and Susan, who answers odd questions about her home.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?5fef733d